// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__qYHJh","reminderIcon":"styles_reminderIcon__m2qg9","bookingType":"styles_bookingType__aR2un"};